module.exports = __webpack_public_path__ + "img/microphone-alt-slash.0aa022f0.svg";